let cartCache = {}
const handleCardNumberValueTimers = new Map();
const TIMEOUT_DURATION = 1500; 


const EVENT_TYPES = {
    ADD_TO_CART: 'add_to_cart',
    REMOVE_FROM_CART: 'remove_from_cart',
    NO_DIFFERENCE: 'no_difference',
}
const getDifference = (id, amount) => {
    const currentAmount = cartCache[id] || 0;
    if (currentAmount === amount) {
        return { type: EVENT_TYPES.NO_DIFFERENCE, amount: 0}
    }

    const difference = amount - currentAmount;
    console.debug(`Product ID: ${id}, Current Amount: ${currentAmount}, New Amount: ${amount}, Difference: ${difference}`);
    if (difference === 0) {
        console.debug(`No difference for product ID: ${id}`);
        return {type: EVENT_TYPES.NO_DIFFERENCE, amount: 0}
    }
    
    if (difference > 0) {
        cartCache[id] = amount; // Update cache
        return {type: EVENT_TYPES.ADD_TO_CART, amount: difference};
    } else {
        cartCache[id] = amount; // Update cache
        return {type: EVENT_TYPES.REMOVE_FROM_CART, amount: Math.abs(difference)};
    }
}


const createEvent = ((cart, eventName, additionalData = {}) => 
{
    const getPriceObj = (shoppingCart, extraData) => {
        if(!shoppingCart || !shoppingCart.products || shoppingCart.products.length === 0) {
            return {};
        }

        if(!Object.keys(extraData).length && !shoppingCart.totalPrice) {
            return {};
        }

        if (shoppingCart.totalPrice) {
            return {currency: "SEK", value: Number(shoppingCart.totalPrice)}
        }

        return {currency: "SEK"};
    }
    
    const priceObj = getPriceObj(cart, additionalData);
    return {
        event: eventName,
        ecommerce: {
            ...priceObj,
            ...additionalData,
            items: cart.products.map((product, i) => ({
                item_name: product.name,
                item_id: product.productId,
                price: Number(product.price),
                quantity: Number(product.amount),
                index: i,
                item_category: product.category,
                item_list_name: product.itemListName,
                item_list_id: product.itemListId,
            })),
        },
    }
});

const assignCache = async () => {
    const response = await fetch('/api/v2/cart/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    });
    if (!response.ok) {
        console.error('Failed to fetch cart data');
        return;
    }

    const cart = await response.json();
    cartCache = cart.products.reduce((acc, product) => {
        console.debug(`Assigning cache for product ID: ${product.productItemId}, Amount: ${product.amount}`);
        acc[product.productItemId] = product.amount;
        return acc;
    }, {});
}



const checkoutAnalytics = async () => {
    const response = await fetch('/api/v2/cart/', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    });
    if (!response.ok) {
        console.error('Failed to fetch cart data');
        return;
    }
    
    const cart = await response.json();
    
    if (!cart || !cart.products || cart.products.length === 0) {
        console.warn('No products in cart');
        return;
    }
    
    const commerceItems = createEvent(cart, 'begin_checkout');
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push(commerceItems)
}

function showProductDetailsAnalytics() {
    document.querySelectorAll('.product-card .product-card__click').forEach(x => x.addEventListener('click', () => {
        const productCard = x.closest('.product-card');
        if (!productCard) return;
        const productData = Object.assign({}, productCard.dataset);
        const eventData = createEvent({products: [productData], totalPrice: productData.price}, 'view_item', );
        window.dataLayer.push({ecommerce: null});
        window.dataLayer.push(eventData);
    }));
}


function viewProductListAnalytics() {
    const products = [...document.querySelectorAll('.product-card')];
    const items = products.map(x => Object.assign({}, x.dataset));
    const eventData = createEvent({products: items}, 'view_item_list', {
        item_list_name: items[0].itemListName || 'Unknown List',
        item_list_id: items[0].itemListId || 'Unknown List ID',
    });
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push(eventData);
    
}

function thankYouAnalytics() {
    const data = window.checkoutData || {products: []};
    
    if(!Array.isArray(data.products) || data.products.length === 0) {
        console.warn('No items in order data');
        return;
    }
    
    const transactionId = window.transactionId;
    
    if (!transactionId) {
        console.warn('Transaction ID is missing');
        return;
    }
    
    window.dataLayer = window.dataLayer || [];
    
    const items = createEvent(data, 'purchase', { transaction_id: transactionId });
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push(items);
}

const addToCartAnalytics = () => {
    const getProductIdFromModal = (button) => (button.closest('.product-modal')?.id || "").replace('product-modal-', '') || "";
    
    
    const modalButtons = [...document.querySelectorAll('.product-modal__action--cart')]
    modalButtons.forEach(button => {
        button.addEventListener('click', async () => {
            await assignCache();
            const modal = button.closest('.product-modal');
            if (!modal) return;
            
            const productId = getProductIdFromModal(button);
            const productElement = document.querySelector(`.product-card[data-product-id="${productId}"]`);
            if (!productElement) {
                console.warn(`Product element not found for ID: ${productId}`);
                return;
            }
            const base = {amount: Number(button.closest('.product-modal__cart-options').querySelector('.product-modal__amount-field').value || 0)}
            const productData = Object.assign(base, productElement.dataset);
            const difference = getDifference(productData.productId, base.amount);
            if (difference.type === EVENT_TYPES.NO_DIFFERENCE) {
                console.log(`No difference for product ID: ${productData.productId}`);
                return;
            }
            
            const eventName = difference.type;
            productData.amount = difference.amount;
            const eventData = createEvent({products: [productData]}, eventName)
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ecommerce: null});
            window.dataLayer.push(eventData);

            cartCache[productData.productId] = productData.amount;
        });
    });
    
    const addToCartButtons = [...document.querySelectorAll('.product-card__action--cart')];
    
    addToCartButtons.forEach(button => {
        button.addEventListener('click', async () => {
            const productCard = button.closest('.product-card');
            if (!productCard) return;
            const productData = Object.assign({}, productCard.dataset);
            productData.amount = 1;
            const eventData = createEvent({products: [productData], totalPrice: productData.price}, 'add_to_cart');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ecommerce: null});
            window.dataLayer.push(eventData);
            cartCache[productData.productId] = productData.amount;
        });
    })
    
    const plusMinusButtons = [...document.querySelectorAll('.product-card__amount-button')]
    
    const plusMinusModalButtons = [...document.querySelectorAll('.product-modal__amount-button')];
    
    plusMinusButtons.forEach(button => {
        button.addEventListener('click', async () => {
            const productCard = button.closest('.product-card');
            if (!productCard) return;

            const productData = Object.assign({}, productCard.dataset);
            if (handleCardNumberValueTimers.has(productData.productId)) {
                clearTimeout(handleCardNumberValueTimers.get(productData.productId));
            }

            handleCardNumberValueTimers.set(productData.productId, setTimeout(async () => {
                const amountField = productCard.querySelector('.product-card__amount-field');
                if (!amountField) return;
                const amount = Number(amountField.value);
                const difference = getDifference(productData.productId, amount);
                if (difference.type === EVENT_TYPES.NO_DIFFERENCE) {
                    return;
                }
                const eventName = difference.type;
                productData.amount = difference.amount;
                const totalPrice = Number(productData.price) * productData.amount;
                const eventData = createEvent({products: [productData], totalPrice}, eventName)
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ecommerce: null});
                window.dataLayer.push(eventData);
                await assignCache();
            }, TIMEOUT_DURATION));

        });
    });
    
    plusMinusModalButtons.forEach(button => {
        button.addEventListener('click', async () => {
            const modal = button.closest('.product-modal');
            if (!modal) return;
            const productId = getProductIdFromModal(button);
            const productElement = document.querySelector(`.product-card[data-product-id="${productId}"]`);
            if (!productElement) {
                console.warn(`Product element not found for ID: ${productId}`);
                return;
            }
            
            const productData = Object.assign({}, productElement.dataset);
            if (handleCardNumberValueTimers.has(productData.productId)) {
                clearTimeout(handleCardNumberValueTimers.get(productData.productId));
            }

            handleCardNumberValueTimers.set(productData.productId, setTimeout(async () => {
                const amountField = modal.querySelector('.product-modal__amount-field');
                if (!amountField) return;
                const amount = Number(amountField.value);
                const difference = getDifference(productData.productId, amount);
                if (difference.type === EVENT_TYPES.NO_DIFFERENCE) {
                    return;
                }
                const eventName = difference.type;
                productData.amount = difference.amount;
                const totalPrice = Number(productData.price) * productData.amount;
                const eventData = createEvent({products: [productData], totalPrice}, eventName)
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ecommerce: null});
                window.dataLayer.push(eventData);
                await assignCache();
            }, TIMEOUT_DURATION));
        });
    });
    
    const inputs = [...document.querySelectorAll('.product-card__amount-field')];
    inputs.forEach(input => {
        input.addEventListener('change', async () => {
            const productCard = input.closest('.product-card');
            if (!productCard) return;

            const productData = Object.assign({}, productCard.dataset);
            if (handleCardNumberValueTimers.has(productData.productId)) {
                clearTimeout(handleCardNumberValueTimers.get(productData.productId));
            }

            handleCardNumberValueTimers.set(productData.productId, setTimeout(async () => {
                const amount = Number(input.value);
                const difference = getDifference(productData.productId, amount);
                if (difference.type === EVENT_TYPES.NO_DIFFERENCE) {
                    return;
                }
                const eventName = difference.type;
                productData.amount = difference.amount;
                const eventData = createEvent({products: [productData]}, eventName)
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ecommerce: null});
                window.dataLayer.push(eventData);
                await assignCache();
            }, TIMEOUT_DURATION));
        });
    });
    
};

export const addToCartCheckoutAnalytics = () => {
    const addButtons = [...document.querySelectorAll('.detailed-cart__amount-button')]
    addButtons.forEach(button => {
        button.addEventListener('click', async () => {
            const productCard = button.closest('.detailed-cart__item');
            if (!productCard) return;

            const productData = Object.assign({}, productCard.dataset);
            if (handleCardNumberValueTimers.has(productData.productId)) {
                clearTimeout(handleCardNumberValueTimers.get(productData.productId));
            }

            handleCardNumberValueTimers.set(productData.productId, setTimeout(async () => {
                const amountField = productCard.querySelector('.detailed-cart__amount-field');
                if (!amountField) return;
                const amount = Number(amountField.value);
                const difference = getDifference(productData.productId, amount);
                if (difference.type === EVENT_TYPES.NO_DIFFERENCE) {
                    return;
                }
                const eventName = difference.type;
                productData.amount = difference.amount;
                const eventData = createEvent({products: [productData]}, eventName)
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ecommerce: null});
                window.dataLayer.push(eventData);
                await assignCache()
            }, TIMEOUT_DURATION))
        });
    });
}

export const removeFromCartCheckoutAnalytics = (e) => {
    const button = e.currentTarget;
    const productCard = button.closest('.detailed-cart__item');
    if (!productCard) return;

    const productData = Object.assign({}, productCard.dataset);

    const currentAmount = cartCache[productData.productId] || 0;
    const eventName = EVENT_TYPES.REMOVE_FROM_CART;
    productData.amount = currentAmount // Use cached amount
    const eventData = createEvent({products: [productData]}, eventName)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push(eventData);
}

document.addEventListener('DOMContentLoaded', async () => {
    await assignCache();
    const checkoutPage = document.querySelector('.shop-checkout');
    if (checkoutPage) {
        await checkoutAnalytics();
        addToCartCheckoutAnalytics();
        return;
    }
    
    const thankYouPage = document.querySelector('.shop-thank-you');
    if (thankYouPage) {
        thankYouAnalytics();
        return;
    }
    
    const productListPage = document.querySelector('.shop-product-list');
    if (productListPage) {
        viewProductListAnalytics();
        showProductDetailsAnalytics();
        addToCartAnalytics();
    }
});
